import { render } from "./modelDiscussion.vue?vue&type=template&id=3582ea22"
import script from "./modelDiscussion.vue?vue&type=script&lang=js"
export * from "./modelDiscussion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__